import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { post } from '../Auths/AuthToken';
import ReactDatePicker from 'react-datepicker';
import { DEFAULT_API_URL, DEFAULT_DATE_FORMATE } from '../../constents';

import uploadfiles from '../../Utilities/handleUploadFiles';
import setUiMessage from '../../Utilities/Tostify';
import { ssnInputMask } from '../../Utilities/MaskInput';
import { useDispatch, useSelector } from 'react-redux';
import { handleGlobalReload } from '../../redux/slices/appSlice';
import { format } from 'date-fns';
import Select from 'react-select';
import Button from '../Button';

const getSelectedOption = (options, value) =>
  (options || []).find((o) => String(o.value) === String(value)) || null;

const buildOptions = (arr, valueKey, labelKey) =>
  (arr || []).map((item) => ({
    value: item?.[valueKey],
    label: item?.[labelKey],
  }));

function AddEditPatInsPopup({ handleClose, patientId, insId, isScan = false }) {
  const dispatch = useDispatch();
  const { user } = useSelector((store) => store.auth);
  const { globalReload } = useSelector((store) => store.app);
  const insCardRef = useRef(null);
  const insCardBackRef = useRef(null);

  const [allData, setAllData] = useState(null);
  const [imageUrl, setImageUrl] = useState(null);
  const [imageUrlBack, setImageUrlBack] = useState(null);
  const [relationShipText, setRelationShipText] = useState(null);
  const [isSelf, setIsSelf] = useState(false);
  const [insRelationship, setInsRelationship] = useState('');

  const [insFormData, setInsFormData] = useState({
    insuranceDetailsType: 0, //
    insuranceDetailsAccPlanName: '', //
    insuranceDetailsProviderType: '', //
    insuranceReasonCode: '', //
    insuranceDetailsPayer: '', //
    insuranceDetailsPolicyNo: '', //
    insuranceDetailsGroupNo: '', //
    insuranceDetailsStart: '', //
    insuranceDetailsEnd: '', //
    patientSignatureDate: '', //
    insuranceDetailsCoPay: '', //
    insuranceDetailsSpecialistCoPay: '', //
    insuranceDetailsDeductible: '', //
    housegrosmonthincome: '',
    dependanceclaimed: '',
    insuranceDetailsAttachInsuranceCard: '', //
    insuranceDetailsAttachInsuranceCardBackSideHidden: '', //
    insuranceDetailsRelationship: '', //
    insuranceDetailExternalId: '',
    patientPolicyInsuredId: '',
    insuranceDetailFirstName: '', //
    insuranceDetailMiddleName: '', //
    insuranceDetailLastName: '', //
    insuranceDetailAddress1: '', //
    insuranceDetailAddress2: '', //
    insuranceDetailCity: '', //
    insuranceDetailState: '', //
    insuranceDetailZip: '', //
    insuranceDetailHomePhone: '', //
    insuranceDetailWorkPhone: '', //
    insuranceDetailsGender: '', //
    insuranceDetailsDob: '', //
    insuranceDetailsSsn: '', //
    insuranceDetailsEmailId: '', //
    otherClaimId: '', //
    insuranceSignature: '', //
    patientSignature: '', //
  });

  const formatDate = (date) => {
    if (!date) return '';
    const d = new Date(date);
    return isNaN(d.getTime()) ? '' : format(d, DEFAULT_DATE_FORMATE);
  };

  useEffect(() => {
    (async () => {
      try {
        const response = await post(
          'api/patient/ManageInsurance/addInsuranceDetail',
          { patientId: patientId, insuranceId: insId }
        );
        if (response?.status === 200) {
          setAllData(response?.data);
          setImageUrl(response?.data?.insuranceDetail?.scan_insurance_card_url);
          setImageUrlBack(
            response?.data?.insuranceDetail?.scan_insurance_card_backside_url
          );
          if (insId) {
            let patDetails = response?.data?.insuranceDetail;
            setInsRelationship(
              response?.data?.insuranceDetail?.subscriber_relationship
            );
            setInsFormData((insFormData) => {
              return {
                ...insFormData,
                insuranceDetailsType: patDetails?.insurance_provider_type,
                insuranceDetailsAccPlanName: patDetails?.account_plan_name,
                insuranceDetailsProviderType: patDetails?.payer_type,
                insuranceReasonCode: patDetails?.insurance_reason_code,
                insuranceDetailsPayer: patDetails?.payer_provider_carrier, //
                insuranceDetailsPolicyNo: patDetails?.policy_number, //
                insuranceDetailsGroupNo: patDetails?.group_number, //
                insuranceDetailsStart:
                  patDetails?.start_date &&
                  patDetails?.start_date !== '0000-00-00'
                    ? new Date(patDetails?.start_date)
                    : null, //
                insuranceDetailsEnd:
                  patDetails?.end_date && patDetails?.end_date !== '0000-00-00'
                    ? new Date(patDetails?.end_date)
                    : null, //
                patientSignatureDate:
                  patDetails?.patient_signature_date &&
                  patDetails?.patient_signature_date !== '0000-00-00'
                    ? new Date(patDetails?.patient_signature_date)
                    : null, //
                insuranceDetailsCoPay: patDetails?.co_pay
                  ? patDetails?.co_pay
                  : '', //
                insuranceDetailsSpecialistCoPay: patDetails?.sp_co_pay
                  ? patDetails?.sp_co_pay
                  : '', //
                insuranceDetailsDeductible: patDetails?.deductible
                  ? patDetails?.deductible
                  : '', //
                insuranceDetailsAttachInsuranceCard:
                  patDetails?.scan_insurance_card, //
                insuranceDetailsAttachInsuranceCardBackSideHidden:
                  patDetails?.scan_insurance_card_backside, //
                insuranceDetailsRelationship:
                  patDetails?.subscriber_relationship, //
                insuranceDetailFirstName: patDetails?.subscriber_first_name, //
                insuranceDetailMiddleName: patDetails?.subscriber_middle_name, //
                insuranceDetailLastName: patDetails?.subscriber_last_name, //
                insuranceDetailAddress1: patDetails?.subscriber_address1, //
                insuranceDetailAddress2: patDetails?.subscriber_address2, //
                insuranceDetailCity: patDetails?.subscriber_city, //
                insuranceDetailState: patDetails?.subscriber_state, //
                insuranceDetailZip: patDetails?.subscriber_zip, //
                insuranceDetailHomePhone: patDetails?.subscriber_home_phone, //
                insuranceDetailWorkPhone: patDetails?.subscriber_work_phone, //
                insuranceDetailsGender:
                  patDetails?.subscriber_gender?.charAt(0).toUpperCase() +
                  patDetails?.subscriber_gender?.slice(1), //
                insuranceDetailsDob:
                  patDetails?.subscriber_dob &&
                  patDetails?.subscriber_dob !== '0000-00-00'
                    ? new Date(patDetails?.subscriber_dob)
                    : null, //
                insuranceDetailsSsn: patDetails?.subscriber_ssn, //
                insuranceDetailsEmailId: patDetails?.subscriber_contact_email, //
                otherClaimId: patDetails?.other_claim_id, //
                insuranceSignature: patDetails?.insured_signature, //
                patientSignature: patDetails?.patient_signature, //
              };
            });
          } else {
            setInsFormData((insFormData) => {
              return {
                ...insFormData,
                insuranceDetailsType: response?.data?.selmaxP,
              };
            });
          }
        }
      } catch (err) {
        setUiMessage('err', err.message);
      }
    })();
  }, [patientId, insId]);

  useEffect(() => {
    setRelationShipText(
      allData?.insRelationList.filter((item) =>
        item.value === insFormData?.insuranceDetailsRelationship
          ? item?.label
          : ''
      )[0]?.label
    );
    if (parseInt(insFormData?.insuranceDetailsRelationship) === 0) {
      setIsSelf(true);
    }
  }, [allData?.insRelationList, insFormData?.insuranceDetailsRelationship]);

  const handleCaptureClick = (type, option) => {
    if (type === 'back') {
      if (option === 'camera') {
        insCardBackRef.current.setAttribute('capture', 'camera');
        insCardBackRef.current.click();
        insCardBackRef.current.removeAttribute('capture');
      } else {
        insCardBackRef.current.click();
      }
    } else {
      if (option === 'camera') {
        insCardRef.current.setAttribute('capture', 'camera');
        insCardRef.current.click();
        insCardRef.current.removeAttribute('capture');
      } else {
        insCardRef.current.click();
      }
    }
  };

  const hadleRemoveCard = (type) => {
    if (type === 'back') {
      setImageUrlBack('');
      setInsFormData({
        ...insFormData,
        insuranceDetailsAttachInsuranceCardBackSideHidden: '',
      });
    } else {
      setImageUrl('');
      setInsFormData({
        ...insFormData,
        insuranceDetailsAttachInsuranceCard: '',
      });
    }
  };

  const handleFileChange = async (e, type) => {
    const file = e.target.files[0];
    const apiUrl = `${DEFAULT_API_URL}/api/patient/ManageInsurance/uploadImage`;
    const responce = await uploadfiles(apiUrl, file);
    if (responce.data?.successCode === 'success') {
      if (file) {
        if (type === 'back') {
          setImageUrlBack(responce?.data?.flePathName);
          setInsFormData({
            ...insFormData,
            insuranceDetailsAttachInsuranceCardBackSideHidden:
              responce?.data?.fleName,
          });
          insCardBackRef.current.value = '';
        } else {
          if (responce.status === 200) {
            setImageUrl(responce?.data?.flePathName);
            setInsFormData({
              ...insFormData,
              insuranceDetailsAttachInsuranceCard: responce?.data?.fleName,
            });
            insCardRef.current.value = '';
          }
        }
      }
    } else {
      setUiMessage('err', responce.data?.msg);
    }
  };

  const handleInSaveUpdate = async () => {
    try {
      if (!insFormData?.insuranceDetailsPayer) {
        setUiMessage('err', 'Please select Payor.');
        return false;
      } else if (!insFormData?.insuranceDetailsPolicyNo) {
        setUiMessage('err', 'Please enter Insured’s ID.');
        return false;
      }
      const response = await post(
        'api/patient/ManageInsurance/saveUpdateInsuranceDetails',
        {
          insuranceId: insId ? insId : '', //it will be blank while add insurance
          patientId: patientId,
          insuranceDetailsType: insFormData?.insuranceDetailsType,
          insuranceDetailsAccPlanName: insFormData?.insuranceDetailsAccPlanName,
          insuranceDetailsProviderType:
            insFormData?.insuranceDetailsProviderType,
          insuranceReasonCode: insFormData?.insuranceReasonCode,
          insuranceDetailsPayer: insFormData?.insuranceDetailsPayer,
          insuranceDetailsPolicyNo: insFormData?.insuranceDetailsPolicyNo,
          insuranceDetailsGroupNo: insFormData?.insuranceDetailsGroupNo,
          insuranceDetailsStart: formatDate(insFormData?.insuranceDetailsStart),
          insuranceDetailsEnd: formatDate(insFormData?.insuranceDetailsEnd),
          patientSignatureDate: formatDate(insFormData?.patientSignatureDate),
          insuranceDetailsCoPay: insFormData?.insuranceDetailsCoPay,
          insuranceDetailsSpecialistCoPay:
            insFormData?.insuranceDetailsSpecialistCoPay,
          insuranceDetailsDeductible: insFormData?.insuranceDetailsDeductible,
          housegrosmonthincome: insFormData?.housegrosmonthincome, //
          dependanceclaimed: insFormData?.dependanceclaimed, //
          insuranceDetailsAttachInsuranceCard:
            insFormData?.insuranceDetailsAttachInsuranceCard,
          insuranceDetailsAttachInsuranceCardBackSideHidden:
            insFormData?.insuranceDetailsAttachInsuranceCardBackSideHidden,
          insuranceDetailsRelationship:
            insFormData?.insuranceDetailsRelationship,
          insuranceDetailExternalId: insFormData?.insuranceDetailExternalId, //
          patientPolicyInsuredId: insFormData?.patientPolicyInsuredId, //
          insuranceDetailFirstName: insFormData?.insuranceDetailFirstName,
          insuranceDetailMiddleName: insFormData?.insuranceDetailMiddleName,
          insuranceDetailLastName: insFormData?.insuranceDetailLastName,
          insuranceDetailAddress1: insFormData?.insuranceDetailAddress1,
          insuranceDetailAddress2: insFormData?.insuranceDetailAddress2,
          insuranceDetailCity: insFormData?.insuranceDetailCity,
          insuranceDetailState: insFormData?.insuranceDetailState,
          insuranceDetailZip: insFormData?.insuranceDetailZip,
          insuranceDetailHomePhone: insFormData?.insuranceDetailHomePhone,
          insuranceDetailWorkPhone: insFormData?.insuranceDetailWorkPhone,
          insuranceDetailsGender: insFormData?.insuranceDetailsGender,
          insuranceDetailsDob: formatDate(insFormData?.insuranceDetailsDob),
          insuranceDetailsSsn: insFormData?.insuranceDetailsSsn,
          insuranceDetailsEmailId: insFormData?.insuranceDetailsEmailId,
          otherClaimId: insFormData?.otherClaimId,
          insuranceSignature: insFormData?.insuranceSignature,
          patientSignature: insFormData?.patientSignature,
          loginUserId: user?.id,
        }
      );
      if (response?.status === 200) {
        handleClose();
        dispatch(handleGlobalReload(!globalReload));
      }
    } catch (err) {
      setUiMessage('err', err.message);
    }
  };

  const handlerelationChange = async (opt) => {
    const value = opt?.value ?? '';
    setInsFormData({
      ...insFormData,
      insuranceDetailsRelationship: value,
    });

    setRelationShipText(
      allData?.insRelationList.filter((item) =>
        item.value === value ? item?.label : ''
      )[0]?.label
    );
    setIsSelf(false);
    if (parseInt(value) === 0) {
      setIsSelf(true);
      const response = await post('api/patient/Patient/editPatientProfile', {
        patientId: patientId,
      });
      if (response?.status === 200) {
        const patDetails = response?.data?.patientDetail;
        setInsFormData((insFormData) => {
          return {
            ...insFormData,
            insuranceDetailFirstName: patDetails?.first_name, //
            insuranceDetailMiddleName: patDetails?.middle_name, //
            insuranceDetailLastName: patDetails?.last_name, //
            insuranceDetailAddress1: patDetails?.address, //
            insuranceDetailAddress2: patDetails?.correspondence_address, //
            insuranceDetailCity: patDetails?.city, //
            insuranceDetailState: patDetails?.state, //
            insuranceDetailZip: patDetails?.zip, //
            insuranceDetailHomePhone: patDetails?.home_phone, //
            insuranceDetailWorkPhone: patDetails?.office_desk_telephone, //
            insuranceDetailsGender:
              patDetails?.gender?.charAt(0).toUpperCase() +
              patDetails?.gender?.slice(1), //
            insuranceDetailsDob:
              patDetails?.date_of_birth &&
              patDetails?.date_of_birth !== '0000-00-00'
                ? new Date(patDetails?.date_of_birth)
                : null, //
            insuranceDetailsSsn: patDetails?.ssn, //
            insuranceDetailsEmailId: patDetails?.email, //
          };
        });
      }
    } else if (parseInt(value) === parseInt(insRelationship)) {
      setInsFormData((insFormData) => {
        return {
          ...insFormData,
          insuranceDetailFirstName:
            allData?.insuranceDetail?.subscriber_first_name, //
          insuranceDetailMiddleName:
            allData?.insuranceDetail?.subscriber_middle_name, //
          insuranceDetailLastName:
            allData?.insuranceDetail?.subscriber_last_name, //
          insuranceDetailAddress1:
            allData?.insuranceDetail?.subscriber_address1, //
          insuranceDetailAddress2:
            allData?.insuranceDetail?.subscriber_address2, //
          insuranceDetailCity: allData?.insuranceDetail?.subscriber_city, //
          insuranceDetailState: allData?.insuranceDetail?.subscriber_state, //
          insuranceDetailZip: allData?.insuranceDetail?.subscriber_zip, //
          insuranceDetailHomePhone:
            allData?.insuranceDetail?.subscriber_home_phone, //
          insuranceDetailWorkPhone:
            allData?.insuranceDetail?.subscriber_work_phone, //
          insuranceDetailsGender:
            allData?.insuranceDetail?.subscriber_gender
              ?.charAt(0)
              .toUpperCase() +
            allData?.insuranceDetail?.subscriber_gender?.slice(1), //
          insuranceDetailsDob:
            allData?.insuranceDetail?.subscriber_dob &&
            allData?.insuranceDetail?.subscriber_dob !== '0000-00-00'
              ? new Date(allData?.insuranceDetail?.subscriber_dob)
              : null, //
          insuranceDetailsSsn: allData?.insuranceDetail?.subscriber_ssn, //
          insuranceDetailsEmailId:
            allData?.insuranceDetail?.subscriber_contact_email, //
        };
      });
    } else {
      setInsFormData((insFormData) => {
        return {
          ...insFormData,
          insuranceDetailFirstName: '', //
          insuranceDetailMiddleName: '', //
          insuranceDetailLastName: '', //
          insuranceDetailAddress1: '', //
          insuranceDetailAddress2: '', //
          insuranceDetailCity: '', //
          insuranceDetailState: '', //
          insuranceDetailZip: '', //
          insuranceDetailHomePhone: '', //
          insuranceDetailWorkPhone: '', //
          insuranceDetailsGender: '', //
          insuranceDetailsDob: '', //
          insuranceDetailsSsn: '', //
          insuranceDetailsEmailId: '', //
        };
      });
    }
  };

  return (
    <div className="modalBackground">
      <div className="insu-addedit-sec center-popup">
        <div className="insu-act-sec">
          <div className="insu-act-sec-bdy-rw flex-sec">
            <div className="insu-act-sec-bdy-rw flex-sec">
              <span className="nsu-act-lbl" style={{ width: '60px', fontSize: '14px', fontWeight: 'bold', lineHeight: '1.5' }}>Priority:</span>
              <span className="nsu-act-val" style={{ width: '40%'}}>
                <Select
                  className="react-select-container width50"
                  classNamePrefix="react-select"
                  isClearable={false}
                  options={buildOptions(allData?.insTypeArr, 'id', 'label')}
                  value={getSelectedOption(
                    buildOptions(allData?.insTypeArr, 'id', 'label'),
                    insFormData?.insuranceDetailsType
                  )}
                  onChange={(opt) =>
                    setInsFormData({
                      ...insFormData,
                      insuranceDetailsType: opt?.value ?? '',
                    })
                  }
                />
              </span>
            </div>
            <Button variant="circle" onClick={handleClose}>
              X
            </Button>
          </div>
          <div className="insu-act-sec-bdy grid-sec">
            <div className="insu-act-sec-hdr">Insurance Card:</div>
            <div className="flex-sec">
              <div className="insu-act-sec-bdy-lft grid-sec">
                <div className="insu-act-sec-bdy-rw brwsenupld-fld flex-sec">
                  <span className="nsu-act-lbl bold">Front View:</span>
                  <span className="nsu-act-val flex-sec">
                    <span
                      className="actn-yes"
                      style={{ width: 'unset', padding: '3px 12px' }}
                      onClick={() => handleCaptureClick('', 'camera')}
                    >
                      Camera
                    </span>
                    <span
                      className="actn-yes"
                      style={{ width: 'unset', padding: '3px 12px' }}
                      onClick={() => handleCaptureClick('', '')}
                    >
                      Browse
                    </span>
                    {isScan && (
                      <span
                        className="actn-yes"
                        style={{ width: 'unset', padding: '3px 12px' }}
                      >
                        Scan
                      </span>
                    )}
                  </span>
                </div>

                <div className="insu-act-sec-bdy-rw grid-sec">
                  <img
                    className="insu-card"
                    src={imageUrl ? imageUrl : './images/dummy-ins-crd.png'}
                    alt={''}
                  />
                  <input
                    type="file"
                    accept=".jpg, .JPG, .jpeg, .JPEG, .png, .PNG, image/*"
                    ref={insCardRef}
                    onChange={(e) => handleFileChange(e)}
                    style={{ display: 'none' }}
                  />
                  <Link
                    className="prnt-card"
                    onClick={() => hadleRemoveCard('')}
                  >
                    Remove Card
                  </Link>
                </div>
              </div>
              <div className="insu-act-sec-bdy-rt grid-sec">
                <div className="insu-act-sec-bdy-rw  brwsenupld-fld flex-sec">
                  <span className="nsu-act-lbl bold">Back View:</span>
                  <span className="nsu-act-val flex-sec">
                    <span
                      className="actn-yes"
                      style={{ width: 'unset', padding: '3px 12px' }}
                      onClick={() => handleCaptureClick('back', 'camera')}
                    >
                      Camera
                    </span>
                    <span
                      className="actn-yes"
                      style={{ width: 'unset', padding: '3px 12px' }}
                      onClick={() => handleCaptureClick('back', '')}
                    >
                      Browse
                    </span>
                    {isScan && (
                      <span
                        className="actn-yes"
                        style={{ width: 'unset', padding: '3px 12px' }}
                      >
                        Scan
                      </span>
                    )}
                  </span>
                </div>

                <div className="insu-act-sec-bdy-rw grid-sec">
                  <img
                    className="insu-card"
                    src={
                      imageUrlBack ? imageUrlBack : './images/dummy-ins-crd.png'
                    }
                    alt={''}
                  />
                  <input
                    type="file"
                    accept=".jpg, .JPG, .jpeg, .JPEG, .png, .PNG, image/*"
                    capture="camera"
                    ref={insCardBackRef}
                    onChange={(e) => handleFileChange(e, 'back')}
                    style={{ display: 'none' }}
                  />
                  <Link
                    className="prnt-card"
                    onClick={() => hadleRemoveCard('back')}
                  >
                    Remove Card
                  </Link>
                </div>
              </div>
            </div>
            <div className="insu-act-sec-hdr">Payor Info:</div>

            <div className="insu-act-sec-bdy-rw flex-sec">
              <div className="insu-act-sec-bdy-lft flex-sec">
                <span className="nsu-act-lbl">
                  Payor:<span className="required-fld">*</span>
                </span>
                <span className="nsu-act-val maroon">
                  <Select
                    className="react-select-container"
                    classNamePrefix="react-select"
                    isClearable
                    placeholder="Select Payor"
                    options={buildOptions(
                      allData?.payerList,
                      'id',
                      'InsuranceName'
                    )}
                    value={getSelectedOption(
                      buildOptions(
                        allData?.payerList,
                        'id',
                        'InsuranceName'
                      ),
                      insFormData?.insuranceDetailsPayer
                    )}
                    onChange={(opt) =>
                      setInsFormData({
                        ...insFormData,
                        insuranceDetailsPayer: opt?.value ?? '',
                      })
                    }
                  />
                </span>
              </div>
              <div className="insu-act-sec-bdy-rt  flex-sec">
                <span className="nsu-act-lbl">PCP CoPay:</span>
                <span className="nsu-act-val">
                  <input
                    type="text"
                    className="inpt-width-nw"
                    placeholder="$0.0"
                    inputMode="numeric"
                    pattern="[0-9]*"
                    value={insFormData?.insuranceDetailsCoPay || ''}
                    onChange={(e) =>
                      setInsFormData({
                        ...insFormData,
                        insuranceDetailsCoPay: e.target.value,
                      })
                    }
                  />
                </span>
              </div>
            </div>
            <div className="insu-act-sec-bdy-rw flex-sec alt-rw">
              <div className="insu-act-sec-bdy-lft flex-sec">
                <span className="nsu-act-lbl">Plan Name:</span>
                <span className="nsu-act-val">
                  <input
                    type="text"
                    className="inpt-width-nw"
                    value={insFormData?.insuranceDetailsAccPlanName || ''}
                    onChange={(e) =>
                      setInsFormData({
                        ...insFormData,
                        insuranceDetailsAccPlanName: e.target.value,
                      })
                    }
                  />
                </span>
              </div>
              <div className="insu-act-sec-bdy-rt  flex-sec">
                <span className="nsu-act-lbl">Specialist CoPay:</span>
                <span className="nsu-act-val">
                  <input
                    type="text"
                    className="inpt-width-nw"
                    placeholder="$0.0"
                    inputMode="numeric"
                    pattern="[0-9]*"
                    value={insFormData?.insuranceDetailsSpecialistCoPay || ''}
                    onChange={(e) =>
                      setInsFormData({
                        ...insFormData,
                        insuranceDetailsSpecialistCoPay: e.target.value,
                      })
                    }
                  />
                </span>
              </div>
            </div>
            <div className="insu-act-sec-bdy-rw flex-sec">
              <div className="insu-act-sec-bdy-lft flex-sec">
                <span className="nsu-act-lbl">Type:</span>
                <span className="nsu-act-val">
                  <Select
                    className="react-select-container"
                    classNamePrefix="react-select"
                    isClearable
                    placeholder="Select Plan"
                    options={allData?.insTypeList || []}
                    value={getSelectedOption(
                      allData?.insTypeList,
                      insFormData?.insuranceDetailsProviderType
                    )}
                    onChange={(opt) =>
                      setInsFormData({
                        ...insFormData,
                        insuranceDetailsProviderType: opt?.value ?? '',
                      })
                    }
                  />
                </span>
              </div>
              <div className="insu-act-sec-bdy-rt  flex-sec">
                <span className="nsu-act-lbl">Deductible:</span>
                <span className="nsu-act-val">
                  <input
                    type="text"
                    className="inpt-width-nw"
                    placeholder="$0.0"
                    inputMode="numeric"
                    pattern="[0-9]*"
                    value={insFormData?.insuranceDetailsDeductible || ''}
                    onChange={(e) =>
                      setInsFormData({
                        ...insFormData,
                        insuranceDetailsDeductible: e.target.value,
                      })
                    }
                  />
                </span>
              </div>
            </div>
            <div className="insu-act-sec-bdy-rw flex-sec  alt-rw">
              <div className="insu-act-sec-bdy-lft flex-sec">
                <span className="nsu-act-lbl">Relationship:</span>
                <span className="nsu-act-val maroon">
                  <Select
                    className="react-select-container"
                    classNamePrefix="react-select"
                    isClearable
                    placeholder="Select Relationship"
                    options={allData?.insRelationList || []}
                    value={getSelectedOption(
                      allData?.insRelationList,
                      insFormData?.insuranceDetailsRelationship
                    )}
                    onChange={handlerelationChange}
                  />
                </span>
              </div>
              <div className="insu-act-sec-bdy-rt  flex-sec">
                <span className="nsu-act-lbl">Insurance Reason Code:</span>
                <span className="nsu-act-val">
                  <Select
                    className="react-select-container"
                    classNamePrefix="react-select"
                    isClearable
                    placeholder="Select Code"
                    options={buildOptions(
                      allData?.insReasonCodeList,
                      'id',
                      'label'
                    )}
                    value={getSelectedOption(
                      buildOptions(
                        allData?.insReasonCodeList,
                        'id',
                        'label'
                      ),
                      insFormData?.insuranceReasonCode
                    )}
                    onChange={(opt) =>
                      setInsFormData({
                        ...insFormData,
                        insuranceReasonCode: opt?.value ?? '',
                      })
                    }
                  />
                </span>
              </div>
            </div>
            <div className="insu-act-sec-bdy-rw flex-sec">
              <div className="insu-act-sec-bdy-lft flex-sec">
                <span className="nsu-act-lbl">
                  Insured’s ID:<span className="required-fld">*</span>
                </span>
                <span className="nsu-act-val maroon">
                  <input
                    type="text"
                    className="inpt-width-nw"
                    placeholder="0000000000"
                    value={insFormData?.insuranceDetailsPolicyNo || ''}
                    onChange={(e) =>
                      setInsFormData({
                        ...insFormData,
                        insuranceDetailsPolicyNo: e.target.value,
                      })
                    }
                  />
                </span>
              </div>
              <div className="insu-act-sec-bdy-rt  flex-sec">
                <span className="nsu-act-lbl">Other claim ID:</span>
                <span className="nsu-act-val">
                  <input
                    type="text"
                    className="inpt-width-nw"
                    placeholder="0000000000"
                    value={insFormData?.otherClaimId || ''}
                    onChange={(e) =>
                      setInsFormData({
                        ...insFormData,
                        otherClaimId: e.target.value,
                      })
                    }
                  />
                </span>
              </div>
            </div>
            <div className="insu-act-sec-bdy-rw flex-sec  alt-rw">
              <div className="insu-act-sec-bdy-lft flex-sec">
                <span className="nsu-act-lbl">Group/FECA #:</span>
                <span className="nsu-act-val">
                  <input
                    type="text"
                    className="inpt-width-nw"
                    placeholder="00000"
                    value={insFormData?.insuranceDetailsGroupNo || ''}
                    onChange={(e) =>
                      setInsFormData({
                        ...insFormData,
                        insuranceDetailsGroupNo: e.target.value,
                      })
                    }
                  />
                </span>
              </div>
              <div className="insu-act-sec-bdy-rt  flex-sec">
                <span className="nsu-act-lbl">Insured's Sig:</span>
                <span className="nsu-act-val">
                  <input
                    type="checkbox"
                    className="inpt-chkbx"
                    checked={
                      insFormData?.insuranceSignature === '1' ? true : false
                    }
                    onChange={(e) =>
                      setInsFormData({
                        ...insFormData,
                        insuranceSignature:
                          e.target.checked === true ? '1' : '0',
                      })
                    }
                  />
                </span>
              </div>
            </div>
            <div className="insu-act-sec-bdy-rw flex-sec">
              <div className="insu-act-sec-bdy-lft flex-sec">
                <span className="nsu-act-lbl">Start Date:</span>
                <span className="nsu-act-val">
                  <ReactDatePicker
                    selected={insFormData?.insuranceDetailsStart}
                    onChange={(date) =>
                      setInsFormData({
                        ...insFormData,
                        insuranceDetailsStart: date,
                      })
                    }
                    className="app-date-picker inpt-width-nw"
                    dateFormat={DEFAULT_DATE_FORMATE}
                    maxDate={insFormData?.insuranceDetailsEnd || new Date()}
                  />
                </span>
              </div>
              <div className="insu-act-sec-bdy-rt  flex-sec">
                <span className="nsu-act-lbl">Patient's Sig:</span>
                <span className="nsu-act-val">
                  <input
                    type="checkbox"
                    className="inpt-chkbx"
                    checked={
                      insFormData?.patientSignature === '1' ? true : false
                    }
                    onChange={(e) =>
                      setInsFormData({
                        ...insFormData,
                        patientSignature: e.target.checked === true ? '1' : '0',
                      })
                    }
                  />
                </span>
              </div>
            </div>
            <div className="insu-act-sec-bdy-rw flex-sec  alt-rw">
              <div className="insu-act-sec-bdy-lft flex-sec">
                <span className="nsu-act-lbl">End Date:</span>
                <span className="nsu-act-val">
                  <ReactDatePicker
                    selected={insFormData?.insuranceDetailsEnd}
                    onChange={(date) =>
                      setInsFormData({
                        ...insFormData,
                        insuranceDetailsEnd: date,
                      })
                    }
                    className="app-date-picker inpt-width-nw"
                    dateFormat={DEFAULT_DATE_FORMATE}
                    minDate={insFormData?.insuranceDetailsStart}
                  />
                </span>
              </div>
              <div className="insu-act-sec-bdy-rt  flex-sec">
                <span className="nsu-act-lbl">Patient's Signature date:</span>
                <span className="nsu-act-val">
                  <ReactDatePicker
                    selected={insFormData?.patientSignatureDate}
                    onChange={(date) =>
                      setInsFormData({
                        ...insFormData,
                        patientSignatureDate: date,
                      })
                    }
                    className="app-date-picker inpt-width-nw"
                    dateFormat={DEFAULT_DATE_FORMATE}
                  />
                </span>
              </div>
            </div>

            <div className="insu-act-sec-hdr">
              Insured Info [{relationShipText}]:
            </div>
            <div className="" style={isSelf ? { pointerEvents: 'none' } : null}>
              <div className="insu-act-sec-bdy-rw flex-sec">
                <div className="insu-act-sec-bdy-lft flex-sec">
                  <span className="nsu-act-lbl">First Name:</span>
                  <span className="nsu-act-val maroon">
                    <input
                      type="text"
                      className="inpt-width-nw"
                      placeholder="First name"
                      value={insFormData?.insuranceDetailFirstName || ''}
                      onChange={(e) =>
                        setInsFormData({
                          ...insFormData,
                          insuranceDetailFirstName: e.target.value,
                        })
                      }
                    />
                  </span>
                </div>
                <div className="insu-act-sec-bdy-rt  flex-sec">
                  <span className="nsu-act-lbl">Zip:</span>
                  <span className="nsu-act-val">
                    <input
                      type="text"
                      className="inpt-width-nw"
                      placeholder="Zip"
                      value={insFormData?.insuranceDetailZip || ''}
                      onChange={(e) =>
                        setInsFormData({
                          ...insFormData,
                          insuranceDetailZip: e.target.value,
                        })
                      }
                    />
                  </span>
                </div>
              </div>
              <div className="insu-act-sec-bdy-rw flex-sec alt-rw">
                <div className="insu-act-sec-bdy-lft flex-sec">
                  <span className="nsu-act-lbl">Middle Name:</span>
                  <span className="nsu-act-val">
                    <input
                      type="text"
                      className="inpt-width-nw"
                      placeholder="Middle name"
                      value={insFormData?.insuranceDetailMiddleName || ''}
                      onChange={(e) =>
                        setInsFormData({
                          ...insFormData,
                          insuranceDetailMiddleName: e.target.value,
                        })
                      }
                    />
                  </span>
                </div>
                <div className="insu-act-sec-bdy-rt  flex-sec">
                  <span className="nsu-act-lbl">Home Phone:</span>
                  <span className="nsu-act-val">
                    <input
                      type="text"
                      className="inpt-width-nw"
                      placeholder="(000) 000-0000"
                      value={insFormData?.insuranceDetailHomePhone || ''}
                      onChange={(e) =>
                        setInsFormData({
                          ...insFormData,
                          insuranceDetailHomePhone: e.target.value,
                        })
                      }
                    />
                  </span>
                </div>
              </div>
              <div className="insu-act-sec-bdy-rw flex-sec">
                <div className="insu-act-sec-bdy-lft flex-sec">
                  <span className="nsu-act-lbl">Last Name:</span>
                  <span className="nsu-act-val">
                    <input
                      type="text"
                      className="inpt-width-nw"
                      placeholder="Last name"
                      value={insFormData?.insuranceDetailLastName || ''}
                      onChange={(e) =>
                        setInsFormData({
                          ...insFormData,
                          insuranceDetailLastName: e.target.value,
                        })
                      }
                    />
                  </span>
                </div>
                <div className="insu-act-sec-bdy-rt  flex-sec">
                  <span className="nsu-act-lbl">Work Phone:</span>
                  <span className="nsu-act-val">
                    <input
                      type="text"
                      className="inpt-width-nw"
                      placeholder="(000) 000-0000"
                      value={insFormData?.insuranceDetailWorkPhone || ''}
                      onChange={(e) =>
                        setInsFormData({
                          ...insFormData,
                          insuranceDetailWorkPhone: e.target.value,
                        })
                      }
                    />
                  </span>
                </div>
              </div>
              <div className="insu-act-sec-bdy-rw flex-sec  alt-rw">
                <div className="insu-act-sec-bdy-lft flex-sec">
                  <span className="nsu-act-lbl">Address1:</span>
                  <span className="nsu-act-val maroon">
                    <input
                      type="text"
                      className="inpt-width-nw"
                      placeholder="Address line one"
                      value={insFormData?.insuranceDetailAddress1 || ''}
                      onChange={(e) =>
                        setInsFormData({
                          ...insFormData,
                          insuranceDetailAddress1: e.target.value,
                        })
                      }
                    />
                  </span>
                </div>
                <div className="insu-act-sec-bdy-rt  flex-sec">
                  <span className="nsu-act-lbl">Sex:</span>
                  <span className="nsu-act-val">
                    <Select
                      className="react-select-container"
                      classNamePrefix="react-select"
                      isClearable
                      placeholder="Select sex"
                      options={allData?.genderArr || []}
                      value={getSelectedOption(
                        allData?.genderArr,
                        insFormData?.insuranceDetailsGender
                      )}
                      onChange={(opt) =>
                        setInsFormData({
                          ...insFormData,
                          insuranceDetailsGender: opt?.value ?? '',
                        })
                      }
                    />
                  </span>
                </div>
              </div>
              <div className="insu-act-sec-bdy-rw flex-sec">
                <div className="insu-act-sec-bdy-lft flex-sec">
                  <span className="nsu-act-lbl">Address2:</span>
                  <span className="nsu-act-val maroon">
                    <input
                      type="text"
                      className="inpt-width-nw"
                      placeholder="Address line two"
                      value={insFormData?.insuranceDetailAddress2 || ''}
                      onChange={(e) =>
                        setInsFormData({
                          ...insFormData,
                          insuranceDetailAddress2: e.target.value,
                        })
                      }
                    />
                  </span>
                </div>
                <div className="insu-act-sec-bdy-rt  flex-sec">
                  <span className="nsu-act-lbl">DOB:</span>
                  <span className="nsu-act-val">
                    <ReactDatePicker
                      selected={insFormData?.insuranceDetailsDob}
                      onChange={(date) =>
                        setInsFormData({
                          ...insFormData,
                          insuranceDetailsDob: date,
                        })
                      }
                      className="app-date-picker inpt-width-nw"
                      dateFormat={DEFAULT_DATE_FORMATE}
                      showMonthDropdown
                      showYearDropdown
                      dropdownMode="select"
                    />
                  </span>
                </div>
              </div>
              <div className="insu-act-sec-bdy-rw flex-sec  alt-rw">
                <div className="insu-act-sec-bdy-lft flex-sec">
                  <span className="nsu-act-lbl">City:</span>
                  <span className="nsu-act-val">
                    <input
                      type="text"
                      className="inpt-width-nw"
                      placeholder="City"
                      value={insFormData?.insuranceDetailCity || ''}
                      onChange={(e) =>
                        setInsFormData({
                          ...insFormData,
                          insuranceDetailCity: e.target.value,
                        })
                      }
                    />
                  </span>
                </div>
                <div className="insu-act-sec-bdy-rt  flex-sec">
                  <span className="nsu-act-lbl">SSN:</span>
                  <span className="nsu-act-val">
                    <input
                      type="text"
                      className="inpt-width-nw"
                      placeholder="000-00-0000"
                      maxLength={9}
                      value={insFormData?.insuranceDetailsSsn || ''}
                      onChange={(e) =>
                        setInsFormData({
                          ...insFormData,
                          insuranceDetailsSsn: ssnInputMask(
                            e.target.value
                          ).replace(/[^0-9-]/g, ''),
                        })
                      }
                    />
                  </span>
                </div>
              </div>
              <div className="insu-act-sec-bdy-rw flex-sec">
                <div className="insu-act-sec-bdy-lft flex-sec">
                  <span className="nsu-act-lbl">State:</span>
                  <span className="nsu-act-val">
                    <Select
                      className="react-select-container"
                      classNamePrefix="react-select"
                      isClearable
                      placeholder="Select State"
                      options={buildOptions(
                        allData?.stateList,
                        'id',
                        'state_name'
                      )}
                      value={getSelectedOption(
                        buildOptions(
                          allData?.stateList,
                          'id',
                          'state_name'
                        ),
                        insFormData?.insuranceDetailState
                      )}
                      onChange={(opt) =>
                        setInsFormData({
                          ...insFormData,
                          insuranceDetailState: opt?.value ?? '',
                        })
                      }
                    />
                  </span>
                </div>
                <div className="insu-act-sec-bdy-rt  flex-sec">
                  <span className="nsu-act-lbl">Email Id:</span>
                  <span className="nsu-act-val">
                    <input
                      type="text"
                      className="inpt-width-nw"
                      placeholder="example@email.com"
                      value={insFormData?.insuranceDetailsEmailId || ''}
                      onChange={(e) =>
                        setInsFormData({
                          ...insFormData,
                          insuranceDetailsEmailId: e.target.value,
                        })
                      }
                    />
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          className="insu-act-sec-bdy-rw"
          style={{
            padding: '10px 10px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-end',
            gap: '8px',
          }}
        >
          <Button variant="primary" onClick={handleInSaveUpdate}>
            {insId ? 'Update' : 'Save'}
          </Button>
          <Button variant="outline" onClick={handleClose}>
            Cancel
          </Button>
        </div>
      </div>
    </div>
  );
}

export default AddEditPatInsPopup;
